var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFavouritesOnIcon)?_c('div',{staticClass:"favourites",on:{"click":function($event){$event.stopPropagation();return _vm.toggleFav.apply(null, arguments)}}},[_c('i',{staticClass:"sport-icon lb-sport sporticon-favourites",class:_vm.iconClass})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }